var _ellipse, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.18,
    cx: 10,
    cy: 10.2456,
    rx: 10,
    ry: 9.64912,
    fill: "#F94054"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_154_7167",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 10,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.30558H13.75M8.59375 5.94867H11.4062",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 8.66248H12.8125V13.864C12.8125 14.0439 12.7384 14.2165 12.6066 14.3437C12.4747 14.4709 12.2959 14.5424 12.1094 14.5424H7.89062C7.70414 14.5424 7.5253 14.4709 7.39344 14.3437C7.26158 14.2165 7.1875 14.0439 7.1875 13.864V8.66248Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.9375,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0625 10.4717L10.9375 12.2809M10.9375 10.4717L9.0625 12.2809",
    stroke: "black",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_154_7167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 4.81793H15.625V15.6732H4.375V4.81793Z",
    fill: "#F94054"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete_red.5c94a88fa6dbfd474cb94f3dbb5f231a.svg";
export { ForwardRef as ReactComponent };